/**
 *
 * App.js
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 *
 * NOTE: while this component should technically be a stateless functional
 * component (SFC), hot reloading does not currently support SFCs. If hot
 * reloading is not a necessity for you then you can refactor it and remove
 * the linting exception.
 */

import React from 'react';
import { hot } from 'react-hot-loader/root';

import { SWRConfig } from 'swr';

import api from 'utils/api';

// Components
import { CookiesNotification, ScrollToTop } from '../../../components/widgets';
import GlobalStyle from '../../../global-styles';
import AnalyticsProvider from '../AnalyticsProvider';
import BootProvider from '../BootProvider';
import JobNotificationProvider from '../JobNotificationProvider';
import PermissionProvider from '../PermissionProvider';
import PhoneConfirmationGuard from '../PhoneConfirmation';
import Routes from '../Routes';
// Local components
import SnackbarProvider from '../SnackbarProvider';
import ThemeProvider from '../ThemeProvider';
import UserProvider from '../UserProvider';

const fetcher = url => api({ method: 'GET', url });

function App() {
  const swrConfig = {
    refreshInterval: 0,
    revalidateOnFocus: false,
    fetcher: (...args) => fetcher(...args).then(res => res.data),
  };
  return (
    <SWRConfig value={swrConfig}>
      <ThemeProvider>
        <SnackbarProvider autoHideDuration={3000}>
          <GlobalStyle />
          <AnalyticsProvider>
            <BootProvider>
              <UserProvider>
                <PermissionProvider>
                  <JobNotificationProvider>
                    <PhoneConfirmationGuard>
                      <Routes />
                    </PhoneConfirmationGuard>
                  </JobNotificationProvider>
                </PermissionProvider>
              </UserProvider>
            </BootProvider>
          </AnalyticsProvider>
          <ScrollToTop />
          <CookiesNotification />
        </SnackbarProvider>
      </ThemeProvider>
    </SWRConfig>
  );
}

export default hot(App);
